import parseBoolean from "./config/parseBoolean"
import "./pt-logic-output.css"
import { getModelFromInput } from '../../common/getModelFunctions';

export default {
	computed: {
		value() {
			const input = this.$el.dataset.inputs;

			return parseBoolean(getModelFromInput(input, this.$model));
		}
	},
	listeners: {
		click: true
	}
};

